import Splide from "@splidejs/splide";
import { boxesSlider } from "./sliders";

export default class BoxesSlider {
    private section: HTMLElement | null;
    private slider: Splide | null = null;

    constructor(section: HTMLElement) {
        this.section = section;

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.section) return;

        this.slider = boxesSlider(this.section);
    };
}
